import React, { useState, useEffect } from "react";
import { TextField, Button } from "@mui/material";
import useUserStore from "../../Stores/userStore";
import "./login-form.css";

function LoginForm() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [isRegister, setIsRegister] = useState(false);
  const setUserData = useUserStore((state) => state.setUser);

  const sendLogin = () => {
    const loginBody = {
      email,
      password,
    };
    let fetchData = {
      method: "POST",
      body: JSON.stringify(loginBody),
      headers: new Headers({
        "Content-Type": "application/json; charset=UTF-8",
      }),
    };
    fetch("https://grupo-serdan-back-iplv-dev.fl0.io/api/users/login", fetchData)
      .then((res) => {
        return res.json();
      })
      .then((res) => {
        if (res.token) {
          setUserData(res);
        }
      });
    // localhost:8080/api/
  };

  const sendRegister = () => {
    const loginBody = {
        email,
        password,
      };
      let fetchData = {
        method: "POST",
        body: JSON.stringify(loginBody),
        headers: new Headers({
          "Content-Type": "application/json; charset=UTF-8",
        }),
      };
      fetch("https://grupo-serdan-back-iplv-dev.fl0.io/api/users", fetchData)
        .then((res) => {
          return res.json();
        })
        .then((res) => {
          console.log(res)
        });
  };

  useEffect(() => {
    setEmail("");
    setPassword("");
    setConfirmPassword("");
  }, [isRegister]);

  const loginInputs = (
    <div>
      <TextField
        variant="outlined"
        placeholder="Email"
        className="mb-2"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
      />
      <TextField
        variant="outlined"
        placeholder="Contraseña"
        className="mb-2"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        type="password"
      />
    </div>
  );

  const registerInputs = (
    <div>
      <TextField
        variant="outlined"
        placeholder="Email"
        className="mb-2"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
      />
      <TextField
        variant="outlined"
        placeholder="Contraseña"
        className="mb-2"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        type="password"
      />
      <TextField
        variant="outlined"
        placeholder="Repite Contraseña"
        className="mb-2"
        value={confirmPassword}
        onChange={(e) => setConfirmPassword(e.target.value)}
        type="password"
      />
    </div>
  );

  return (
    <div>
        <p className="mb-2">{isRegister ? 'Registro' : 'Iniciar Sesión'}</p>
      {isRegister ? registerInputs : loginInputs}
      <div className="button-container">
        <Button
          className="register-button"
          type="submit"
          variant="contained"
          onClick={() => setIsRegister(!isRegister)}
        >
          {isRegister ? "Iniciar sesión" : "Registrarme"}
        </Button>
        <Button
          type="submit"
          variant="contained"
          onClick={isRegister ? sendRegister : sendLogin}
        >
          Enviar
        </Button>
      </div>
    </div>
  );
}

export default LoginForm;
